// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kVwT","type":"styles_type__3pKeg","choices":"styles_choices__3Il-_"};